var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.5,
    height: 12.706,
    viewBox: "0 0 18.5 12.706",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5985",
    "data-name": "Group 5985",
    transform: "translate(-524.954 -182.055)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18041",
    "data-name": "Path 18041",
    d: "M87.086,120.62H79.631v1.644a.381.381,0,1,1-.763,0V120.62H71.412A1.415,1.415,0,0,0,70,122.033v9.88a1.415,1.415,0,0,0,1.413,1.413H87.086a1.415,1.415,0,0,0,1.413-1.413v-9.88A1.415,1.415,0,0,0,87.086,120.62Zm-11.633,2.224a1.639,1.639,0,1,1-1.639,1.64A1.641,1.641,0,0,1,75.453,122.844Zm3.7,8.2h-7.4a.1.1,0,0,1-.1-.1,3.8,3.8,0,1,1,7.592,0,.1.1,0,0,1-.1.1Zm6.509-2.4H80.857a.381.381,0,0,1,0-.763h4.806a.381.381,0,0,1,0,.763Zm0-2.977H80.857a.381.381,0,0,1,0-.763h4.806a.381.381,0,0,1,0,.763Z",
    transform: "translate(454.955 61.435)",
    fill: "#2a2a2a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18042",
    "data-name": "Path 18042",
    d: "M339.223,56.567a.381.381,0,0,1-.763,0V54.773h.763Z",
    transform: "translate(195.363 127.282)",
    fill: "#2a2a2a"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMid);
export default __webpack_public_path__ + "static/media/mid.b8ef5774d40ada80661ee6f2ae28d5a4.svg";
export { ForwardRef as ReactComponent };